import { Component, input } from '@angular/core';
import { MyOrders } from 'src/app/models/myorders.model';
import { BIKRate } from 'src/app/models/vehicle-order-driver-bik-preference.model';
import { StandardVehicleInfoModalService } from 'src/app/services/vehicle-order-info/standard-vehicle-info-modal.service';
import { DateUtils } from 'src/app/helpers/date/dateUtils';
import { DATE_FORMATS } from 'src/app/helpers/date/date-formats.constants';

@Component({
  selector: 'app-my-vehicle-order',
  templateUrl: './my-vehicle-order.component.html',
  styleUrls: ['./my-vehicle-order.component.scss'],
  standalone: false
})
export class MyVehicleOrderComponent {
  order = input.required<MyOrders>();
  selectedBIK = input<BIKRate>(20);

  constructor(public readonly standardVehicleInfoModalService: StandardVehicleInfoModalService) { }

  // dd/MM/yyyy strings (API format) are normalized internally by DateUtils.format before rendering.
  getEstimatedDeliveryDate(): string | null {
    const value = this.order().estimated_delivery_date;
    if (!value) {
      return null;
    }

    return DateUtils.format(value, false, DATE_FORMATS.DATE_DD_MM_YYYY);
  }
}
